// extracted by mini-css-extract-plugin
export var logo = "_lf-2";
export var logoWrapper = "_lf-1";
export var strip = "_lf-0";